import DatepickerIcon from "@assets/images/date-picker.svg";
import externalLinkIcon from "@assets/images/external-link.svg";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ModalAddress from "@saleor/changeOrderDomestic/components/ModalAddress";
import ModalInputParameter from "@saleor/changeOrderDomestic/components/ModalInputParameter/ModalInputParameter";
import {
  getNetPriceForProductGroup1,
  getNetPriceForProductGroup2
} from "@saleor/changeOrderDomestic/utils";
import Checkbox from "@saleor/components/Checkbox";
import DatePicker from "@saleor/components/DatePicker/DatePicker";
import DatePickerApplyAll from "@saleor/components/DatePickerApplyAll";
import DecimalFormat from "@saleor/components/DecimalFormat";
import MyTypography from "@saleor/components/MyTypography";
import NumberFormat from "@saleor/components/NumberFormat/NumberFormat";
import PopoverApplyAll from "@saleor/components/PopoverApplyAll";
import { SingleTextField } from "@saleor/components/SingleTextField";
import Skeleton from "@saleor/components/Skeleton";
import StickyHorizontalScrollBar from "@saleor/components/StickyHorizontalScrollBar";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { BIG_ROW_NUMBER_SET } from "@saleor/components/TablePagination/constants";
import { TablePaginationCustom } from "@saleor/components/TablePaginationCustom";
import TextAreaField from "@saleor/components/TextAreaField";
import CashSaleForm, {
  CashSaleFormProps
} from "@saleor/createOrder/components/CashSaleForm";
import { DomesticOrderSortField } from "@saleor/createOrderDomestic/urls";
import { getRealTimePartnerDataByType } from "@saleor/createOrderDomestic/utils";
import FullScreenButton from "@saleor/createOrderExport/components/FullScreenButton";
import EmptyProduct from "@saleor/createOrderExport/views/CartDetailExport/EmptyProduct";
import {
  Get_Realtime_PartnerMutation,
  RealtimePartnerType,
  usePassParameterToIPlanMutation
} from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import useDebounce from "@saleor/hooks/useDebounce";
import { ChangeEvent } from "@saleor/hooks/useForm";
import { renderCollection } from "@saleor/misc";
import { ListProps, SortPage } from "@saleor/types";
import { PROD_CATEG_1, SALE_CATEG_1 } from "@saleor/utils/constants";
import { calculateNewTotalWeightCommon } from "@saleor/utils/number";
import { getArrowDirection } from "@saleor/utils/sort";
import classNames from "classnames";
import { FormikProps } from "formik";
import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState
} from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

import useStyles from "./styles";
interface lineType {
  __typename: "TempOrderLine";
  id: string | null;
  indexNumber: number | null;
  quantity: number | null;
  plant: string | null;
  price: number | null;
  itemNo: number | null;
  netPrice: number | null;
  prcGroup1: string | null;
  requestDate: any;
  errorQuantity: boolean;
  internalCommentsToWarehouse: string | null;
  externalCommentsToCustomer: string | null;
  shippingMark: string | null;
  internalCommentsToLogistic: string | null;
  shipTo: string | null;
  paymentTerm: string | null;
  productInformation: string | null;
  weightUnit: string | null;
  weight: number | null;
  inquiryMethod: string | null;
  order: { __typename: "TempOrder"; id: string | null } | null;
  product: {
    __typename: "TempProduct";
    id: string | null;
    name: string | null;
    code: string | null;
    salesUnit: string | null;
  } | null;
  variant: {
    __typename: "TempProductVariant";
    id: string | null;
    name: string | null;
    weight: string | null;
    salesUnit: string | null;
    descriptionEn: string | null;
  } | null;
  checkoutLine: {
    __typename: "ContractCheckoutLine";
    id: string | null;
  } | null;
  unit: string | null;
  contractProduct: {
    __typename: "TempContractProduct";
    name: string | null;
    currency: string | null;
    id: string | null;
    total: number | null;
    remain: number | null;
    price: number | null;
    plant: string | null;
    deliveryOver: number | null;
    deliveryUnder: number | null;
  } | null;
}

interface ItemDetailsTabProps
  extends ListProps,
    SortPage<DomesticOrderSortField> {
  currency: string;
  addressShipTo: any[];
  formik?: FormikProps<any>;
  reFetchOrderList: () => void;
  onPreviousFirstPage: () => void;
  onNextLastPage: () => void;
  disabled: boolean;
  latestPageItemNumber: number | null;
  onNextPage: () => void;
  onPreviousPage: () => void;
  setListOrderLine: (list) => void;
  totalCount: number;
  currentTab?: string;
  orderLineListAll: Array<lineType | null>;
  currentData: Array<lineType | null>;
  isSelectDelete: (data) => boolean;
  listSelectDelete: string[];
  setDelete: (value) => void;
  resetDelete: () => void;
  toggleDelete: (data) => void;
  realtimePartnerData: Get_Realtime_PartnerMutation;
  getRealtimePartnerData: () => void;
  isCashSaleOrder?: boolean;
  cashSaleFormProps?: CashSaleFormProps;
}

export interface ItemDetailsTabRef {
  forceChangeTab: (tab: ItemTab) => void;
}

export enum ItemTab {
  tabA = "orderInformation",
  tabC = "additionalData",
  tabD = "cashSale"
}

const tabList = [
  {
    id: "order-information-tab",
    code: ItemTab.tabA,
    title: "ข้อมูลสั่งซื้อ",
    index: "z3",
    first: true
  },
  {
    id: "additional-tab",
    code: ItemTab.tabC,
    title: "Additional Data",
    index: "z2",
    first: false
  },
  {
    id: "cash-sale-tab",
    code: ItemTab.tabD,
    title: "Cash Sale",
    index: "z1",
    first: false
  }
];

const ItemDetailsTab: ForwardRefRenderFunction<
  ItemDetailsTabRef,
  ItemDetailsTabProps
> = (props, ref) => {
  const {
    formik,
    // reFetchOrderList,
    onPreviousFirstPage,
    onNextLastPage,
    disabled,
    latestPageItemNumber,
    onNextPage,
    onPreviousPage,
    // setListOrderLine,
    totalCount,
    orderLineListAll,
    pageInfo,
    settings,
    sort,
    onSort,
    onUpdateListSettings,
    isSelectDelete,
    listSelectDelete,
    setDelete,
    resetDelete,
    toggleDelete,
    currentTab,
    currentData,
    getRealtimePartnerData,
    realtimePartnerData,
    currency,
    isCashSaleOrder,
    cashSaleFormProps
  } = props;
  const [{ fullScreen }] = useAppState();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [activeTab, setActiveTab] = useState<ItemTab>(ItemTab.tabA);
  const [reRender, setReRender] = useState<boolean>(false);
  const [resetApplyDate, setResetApplyDate] = useState<boolean>(false);
  const [resetApplyPlant, setResetApplyPlant] = useState<boolean>(false);

  const [openInputParameter, setOpenInputParameter] = useState<boolean>(false);
  const [currentSelect, setCurrentSelect] = useState<string>(null);
  const [currentSelectAddress, setCurrentSelectAddress] = useState<number>(0);
  const [openPlant, setOpenPlant] = useState<boolean>(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const itemRef = useRef(0);

  const classes = useStyles();
  const intl = useIntl();

  const onTabClick = tab => {
    setActiveTab(tab);
  };

  useImperativeHandle(ref, () => ({
    forceChangeTab: (tab: ItemTab) => onTabClick(tab)
  }));

  const [openModalAddress, setOpenModalAddress] = useState<boolean>(false);
  const handleOpenModalAddress = id => {
    setCurrentSelectAddress(id);
    const line = formik.values.lines.find(item => item.id === id);
    if (line) {
      formik.setFieldValue("shipTo", line.shipTo, false);
    }
    setOpenModalAddress(true);
  };
  const handleCloseModalAddress = () => {
    setOpenModalAddress(false);
  };

  const handleApplyAllRequestDate = value => {
    setResetApplyDate(prevState => !prevState);
    formik.setFieldValue(
      "lines",
      formik.values.lines.map(item => ({ ...item, requestDate: value }))
    );
  };

  const handleOnApplyAllPlant = value => {
    setResetApplyPlant(prevState => !prevState);
    formik.setFieldValue(
      "lines",
      formik.values.lines.map(item => ({ ...item, plant: value }))
    );
    setOpenPlant(false);
  };

  const handleInputParam = id => {
    setCurrentSelect(id);
    setOpenInputParameter(true);
  };

  const handleCheckboxAllDelete = () => {
    if (listSelectDelete.length === currentData.length) {
      resetDelete();
      return;
    }
    setDelete(currentData.map(item => item.id));
  };

  const handleOnApplyAddress = shipTo => {
    formik.setFieldValue(
      "lines",
      formik.values.lines.map(el =>
        el.id === currentSelectAddress ? { ...el, shipTo } : el
      )
    );
  };

  const [
    passParameter,
    { loading: loadingPassParameter }
  ] = usePassParameterToIPlanMutation();

  const handleSaveInputParam = inquiryMethodCode => {
    formik.setFieldValue(
      "lines",
      formik.values.lines.map(el =>
        el.id === currentSelect ? { ...el, inquiryMethodCode } : el
      )
    );
    passParameter({
      variables: {
        orderLineId: currentSelect,
        inquiryMethodCode
      }
    }).then(result => {
      if (result?.data?.passParameterToIPlan?.status) {
        setCurrentSelect(null);
        setOpenInputParameter(false);
      }
    });
  };

  // const handleChangeWeightUnit = (event: ChangeEvent, index: number) => {
  //   const item = formik.values.lines[index];
  //   formik.setFieldValue(
  //     `lines[${index}].weight`,
  //     calculateNewTotalWeightCommon(
  //       item?.quantity,
  //       item?.weightPerUnit,
  //       event.target.value,
  //       item?.rootUnit
  //     )
  //   );
  //   formik.handleChange(event);
  // };

  const isProductCateg1 = orderLineListAll.some(item =>
    PROD_CATEG_1(item?.prcGroup1)
  );

  const checkQuantity = (event: ChangeEvent, index: number) => {
    formik.handleChange(event);
    itemRef.current = index;
  };

  useEffect(() => {
    const index = itemRef.current;
    const item = formik.values.lines[index];

    const newList = [...formik.values.lines];
    const calculator = {};

    newList.forEach(line => {
      const product = calculator[line.contractProduct.id];
      const quantity = Number(line.quantity || 0);
      const weight = Number(line.variant?.weight || 0);

      if (product) {
        if (isProductCateg1) {
          product.total += quantity * weight;
        } else {
          product.total += quantity;
        }
        product.remain = line.contractProduct.remain;
      } else {
        calculator[line.contractProduct.id] = {
          total: isProductCateg1 ? quantity * weight : quantity,
          remain: line.contractProduct.remain
        };
      }
    });

    let hasChanged = false;
    const updatedLines = newList.map((line, stt) => {
      if (stt === index) {
        line.weight = calculateNewTotalWeightCommon(
          line?.quantity,
          item?.weightPerUnit,
          item?.weightUnit || "ตัน",
          item?.rootUnit
        );
      }

      if (
        line?.contractProduct.id !== item?.contractProduct?.id ||
        !line.quantity
      ) {
        return line;
      }

      const calculatorByProduct = calculator[line.contractProduct.id];
      const errorQuantity =
        calculatorByProduct?.total > calculatorByProduct?.remain ||
        parseFloat(line.quantity) === 0;

      if (line.errorQuantity !== errorQuantity) {
        hasChanged = true;
        return {
          ...line,
          errorQuantity
        };
      }
      return line;
    });

    if (hasChanged) {
      formik.setFieldValue("lines", updatedLines, true);
    }
  }, [formik.values.lines, itemRef.current, isProductCateg1]);

  const checkQuantityDebounce = useDebounce(checkQuantity, 0);

  const handleQuantity = (event: ChangeEvent, index: number) => {
    // const item = formik.values.lines[index];
    // const value = parseInt(event.target.value || 0, 10) || 0;
    // formik.setFieldValue(
    //   `lines[${index}].weight`,
    //   calculateNewTotalWeightCommon(
    //     value,
    //     item?.weightPerUnit,
    //     item?.weightUnit || "ตัน",
    //     item?.rootUnit
    //   )
    // );
    // formik.handleChange(event);
    checkQuantityDebounce(event, index);
  };

  useEffect(() => {
    if (openModalAddress) {
      getRealtimePartnerData();
    }
  }, [openModalAddress]);

  const options = useMemo(
    () =>
      getRealTimePartnerDataByType(
        RealtimePartnerType.SHIP_TO,
        realtimePartnerData
      ),
    [realtimePartnerData]
  );

  const handleDate = e => {
    formik.handleChange(e);
  };

  const renderCellHeadA = (
    <>
      <TableCellHeader
        className={classNames(classes.colA1, classes.noBorderRight)}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"} className={classes.qtyHeaderTxt}>
          {intl.formatMessage({ defaultMessage: "จำนวน" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA2} rowSpan={2}>
        <MyTypography variant={"body3"}>
          {intl.formatMessage({
            defaultMessage: "หน่วย"
          })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        style={{ padding: 10 }}
        className={classNames(classes.colA3, classes.noBorderRight)}
        rowSpan={2}
        textAlign={"right"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "น้ำหนัก" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA4}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA5)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"} className={classes.boxPlant}>
          <span>{intl.formatMessage({ defaultMessage: "Plant" })}</span>
          <Button
            id="plantApplyAll"
            data-testid="plantApplyAll"
            ref={anchorRef}
            className={classNames(
              classes.buttonApply,
              openPlant && classes.btnApplyOpen
            )}
            variant="contained"
            onClick={() => setOpenPlant(true)}
          >
            {openPlant && (
              <SVG src={DatepickerIcon} className={classes.svgDatePicker} />
            )}
            Apply all
          </Button>
          <PopoverApplyAll
            anchorEl={anchorRef.current}
            onClose={() => setOpenPlant(false)}
            open={openPlant}
            onOk={handleOnApplyAllPlant}
            title={"Plant"}
            maxLengthInput={4}
          />
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA10)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"} className={classes.boxPlant}>
          <span>{intl.formatMessage({ defaultMessage: "Request Date" })}</span>
          <DatePickerApplyAll onApplyAll={handleApplyAllRequestDate} />
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA6)}
        rowSpan={2}
        textAlign={"right"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "ราคา/หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA7)}
        rowSpan={2}
        textAlign={"right"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "ราคารวมสุทธิ" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA8}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Currency" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA9} rowSpan={2} textAlign="center">
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "เงื่อนไขการชำระเงิน" })}
        </MyTypography>
      </TableCellHeader>
      {isProductCateg1 && (
        <TableCellHeader
          className={classes.colA11}
          rowSpan={2}
          textAlign={"center"}
        >
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({ defaultMessage: "( P )" })}
          </MyTypography>
        </TableCellHeader>
      )}
    </>
  );

  const renderCellHeadC = (
    <>
      <TableCellHeader className={classes.colC1} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Ship-to Party" })}
        </MyTypography>
      </TableCellHeader>
      {/* <TableCellHeader className={classes.colC4} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Internal Comments to Logistic"
          })}
        </MyTypography>
      </TableCellHeader> */}
      <TableCellHeader className={classes.colC2} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Internal Comments to Warehouse"
          })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colC3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "External Comments to Customer"
          })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colC3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Remark"
          })}
        </MyTypography>
      </TableCellHeader>
      {/* <TableCellHeader className={classes.colC5} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Production information" })}
        </MyTypography>
      </TableCellHeader> */}
    </>
  );

  useEffect(() => {
    if (fullScreen || activeTab) {
      setReRender(prevState => !prevState);
    }
  }, [fullScreen, activeTab]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef!.current!.scrollLeft = 0;
    }
  }, [activeTab]);

  const getTextError = (field, index) =>
    !!formik.errors.lines?.[index]?.[field] ? (
      <div className={classes.textError}>
        {formik.errors.lines?.[index]?.[field]}
      </div>
    ) : (
      ""
    );

  return (
    <div className={classes.root}>
      {currentData?.length > 0 && (
        <>
          <div className={classes.topBox}>
            <FullScreenButton />
          </div>
          <div className={classes.tabBox}>
            {renderCollection(tabList, tab => {
              if (tab.code === ItemTab.tabD && !isCashSaleOrder) {
                return null;
              }

              return (
                <div
                  key={tab.code}
                  className={classNames(
                    activeTab === tab.code ? classes.zMax : classes[tab.index]
                  )}
                >
                  <Button
                    id={tab.id}
                    data-testid={tab.id}
                    onClick={() => onTabClick(tab.code)}
                    className={classNames(
                      !tab.first && classes.tabB,
                      activeTab === tab.code
                        ? classes.tableTabActive
                        : classes.tableTab
                    )}
                  >
                    <MyTypography
                      variant={"body2"}
                      className={classNames(
                        activeTab === tab.code
                          ? classes.innerTabActive
                          : classes.innerTab
                      )}
                    >
                      {tab.title}
                    </MyTypography>
                  </Button>
                </div>
              );
            })}
          </div>
          {[ItemTab.tabA, ItemTab.tabC].includes(activeTab) ? (
            <>
              <div
                className={classes.tableRoot}
                style={{ overflowX: "auto" }}
                ref={containerRef}
              >
                <Table data-testid="table-item-details">
                  <TableHead>
                    <TableRow>
                      <TableCellHeader
                        rowSpan={2}
                        align={"center"}
                        className={classNames(
                          classes.cellCheckBox,
                          classes.tableHeader,
                          classes.borderLeftMain,
                          classes.freezeCell
                        )}
                      >
                        <div className={classes.boxCheckBox}>
                          <span className={classes.delete}>Delete</span>
                          <Checkbox
                            id="deleteCheckboxAll"
                            data-testid="deleteCheckboxAll"
                            className={classes.checkBox}
                            size={"small"}
                            checked={
                              listSelectDelete.length === currentData.length
                            }
                            indeterminate={
                              listSelectDelete.length > 0 &&
                              listSelectDelete.length < currentData.length
                            }
                            onClick={() => handleCheckboxAllDelete()}
                          />
                        </div>
                      </TableCellHeader>
                      <TableCellHeader
                        className={classes.freezeCell1}
                        rowSpan={2}
                        direction={
                          sort.sort === DomesticOrderSortField.item_no
                            ? getArrowDirection(sort.asc)
                            : undefined
                        }
                        arrowPosition="right"
                        onClick={() => onSort(DomesticOrderSortField.item_no)}
                        data-testid="sort-item-no-button"
                      >
                        <MyTypography variant={"subtitle3"}>
                          {intl.formatMessage({ defaultMessage: "Item No." })}
                        </MyTypography>
                      </TableCellHeader>
                      <TableCellHeader
                        className={
                          activeTab === ItemTab.tabC
                            ? classes.freezeCell2Details
                            : classes.freezeCell2
                        }
                        rowSpan={2}
                      >
                        <MyTypography variant={"subtitle3"}>
                          {intl.formatMessage({
                            defaultMessage: "Material Code"
                          })}
                        </MyTypography>
                      </TableCellHeader>
                      <TableCellHeader
                        className={
                          activeTab === ItemTab.tabC
                            ? classes.freezeCell2Details
                            : classes.freezeCell2
                        }
                        rowSpan={2}
                      >
                        <MyTypography variant={"subtitle3"}>
                          {intl.formatMessage({
                            defaultMessage: "Material Description."
                          })}
                        </MyTypography>
                      </TableCellHeader>
                      {activeTab === ItemTab.tabA && renderCellHeadA}
                      {activeTab === ItemTab.tabC && renderCellHeadC}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {currentData &&
                    currentData.length > 0 &&
                    formik.values.lines.length > 0 ? (
                      renderCollection(currentData, line => {
                        const index = line.indexNumber;
                        return (
                          <TableRow key={line.id}>
                            <TableCell
                              className={classNames(
                                classes.borderLeftMain,
                                classes.freezeCell
                              )}
                            >
                              <Checkbox
                                id={`lines[${index}].deleteCheckbox`}
                                data-testid={`lines[${index}].deleteCheckbox`}
                                className={classes.checkBox}
                                size={"small"}
                                checked={isSelectDelete(line.id)}
                                onClick={() => toggleDelete(line.id)}
                              />
                            </TableCell>
                            <TableCell
                              className={classes.freezeCell1}
                              align={"center"}
                            >
                              <MyTypography variant={"body3"}>
                                {line?.itemNo}
                              </MyTypography>
                            </TableCell>
                            <TableCell
                              className={
                                activeTab === ItemTab.tabC
                                  ? classes.freezeCell2Details
                                  : classes.freezeCell2
                              }
                            >
                              <MyTypography variant={"body3"}>
                                {line?.product?.code}
                              </MyTypography>
                            </TableCell>
                            <TableCell
                              className={
                                activeTab === ItemTab.tabC
                                  ? classes.freezeCell2Details
                                  : classes.freezeCell2
                              }
                            >
                              <MyTypography variant={"body3"}>
                                {line?.variant?.descriptionEn}
                              </MyTypography>
                            </TableCell>
                            {activeTab === ItemTab.tabA && (
                              <>
                                <TableCell colSpan={2}>
                                  <div className={classes.boxQuantity}>
                                    <NumberFormat
                                      id={`lines[${index}].quantity`}
                                      data-testid={`lines[${index}].quantity`}
                                      customClass={classes.numberInput}
                                      name={`lines[${index}].quantity`}
                                      onChange={e => handleQuantity(e, index)}
                                      allowLeadingZeros={
                                        !SALE_CATEG_1(line?.unit)
                                      }
                                      decimalScale={
                                        SALE_CATEG_1(line?.unit) ? 3 : 0
                                      }
                                      placeholder={
                                        SALE_CATEG_1(line?.unit) ? "0.000" : "0"
                                      }
                                      rightAlignPlaceholder={SALE_CATEG_1(
                                        line?.unit
                                      )}
                                      fixedDecimalScale={SALE_CATEG_1(
                                        line?.unit
                                      )}
                                      value={formik?.values?.lines[
                                        index
                                      ]?.quantity.toString()}
                                      error={
                                        !!formik.errors.lines?.[index]
                                          ?.quantity || !!line?.errorQuantity
                                      }
                                    />
                                    <MyTypography
                                      variant={"body3"}
                                      className={classes.ml20}
                                    >
                                      {line?.unit}
                                    </MyTypography>
                                  </div>
                                  <div className={classes.textError}>
                                    {line?.errorQuantity &&
                                      "จำนวนที่สั่งมีมากกว่าจำนวนคงเหลือ"}
                                  </div>
                                  {getTextError("quantity", index)}
                                </TableCell>
                                <TableCell
                                  align={"right"}
                                  className={classes.noBorderRight}
                                >
                                  <MyTypography variant={"body3"}>
                                    <DecimalFormat
                                      value={
                                        formik?.values?.lines[index]?.weight
                                      }
                                      isGrayDecimal={false}
                                      countDecimal={3}
                                    />
                                  </MyTypography>
                                </TableCell>
                                <TableCell align="center">
                                  <MyTypography variant={"body3"}>
                                    {formik?.values?.lines[index]?.weightUnit}
                                  </MyTypography>
                                  {/* <SingleTextField
                                showPlaceHolderWhenSelect
                                InputProps={{
                                  classes: { input: classes.txtInputSelect }
                                }}
                                className={classes.selectField}
                                onChange={e => handleChangeWeightUnit(e, index)}
                                placeholder={"Select"}
                                name={`lines[${index}].weightUnit`}
                                value={formik.values.lines[index]?.weightUnit}
                              /> */}
                                </TableCell>
                                <TableCell>
                                  <SingleTextField
                                    id={`lines[${index}].plant`}
                                    InputProps={{
                                      inputProps: {
                                        "data-testid": `lines[${index}].plant`
                                      }
                                    }}
                                    key={`lines[${index}${resetApplyPlant}].plant`}
                                    name={`lines[${index}].plant`}
                                    value={formik?.values?.lines[index]?.plant}
                                    className={classes.textFieldCustom}
                                    onChange={formik.handleChange}
                                    maxLengthProps={4}
                                  />
                                </TableCell>
                                <TableCell>
                                  <DatePicker
                                    id={`lines[${index}].requestDate`}
                                    data-testid={`lines[${index}].requestDate`}
                                    noBlock
                                    key={`lines[${index}${resetApplyDate}].requestDate`}
                                    name={`lines[${index}].requestDate`}
                                    value={
                                      formik?.values?.lines[index]?.requestDate
                                    }
                                    onChange={handleDate}
                                    onAccept={formik.handleChange}
                                    error={
                                      !!formik.errors.lines?.[index]
                                        ?.requestDate
                                    }
                                    helperText={""}
                                  />
                                  {getTextError("requestDate", index)}
                                </TableCell>
                                <TableCell align={"right"}>
                                  <MyTypography variant={"body3"}>
                                    <DecimalFormat
                                      value={
                                        formik?.values?.lines[index]?.price
                                      }
                                      isGrayDecimal={false}
                                      countDecimal={2}
                                    />
                                  </MyTypography>
                                </TableCell>
                                <TableCell align={"right"}>
                                  <MyTypography variant={"body3"}>
                                    {isProductCateg1 ? (
                                      <DecimalFormat
                                        value={getNetPriceForProductGroup1(
                                          formik?.values?.lines[index]?.price,
                                          formik?.values?.lines[index]
                                            ?.weightPerUnit,
                                          formik?.values?.lines[index]?.quantity
                                        )}
                                        isGrayDecimal={false}
                                        countDecimal={2}
                                      />
                                    ) : (
                                      <DecimalFormat
                                        value={getNetPriceForProductGroup2(
                                          formik?.values?.lines[index]?.price,
                                          formik?.values?.lines[index]?.quantity
                                        )}
                                        isGrayDecimal={false}
                                        countDecimal={2}
                                      />
                                    )}
                                  </MyTypography>
                                </TableCell>
                                <TableCell align={"center"}>
                                  <MyTypography variant={"body3"}>
                                    {currency}
                                  </MyTypography>
                                </TableCell>
                                <TableCell align="center">
                                  <MyTypography variant={"body3"}>
                                    {line.paymentTerm}
                                  </MyTypography>
                                </TableCell>
                                {isProductCateg1 && (
                                  <TableCell>
                                    <Button
                                      id={`lines[${index}].externalLink`}
                                      data-testid={`lines[${index}].externalLink`}
                                      className={classes.btnExternalLink}
                                      variant="contained"
                                      color="secondary"
                                      onClick={() => handleInputParam(line.id)}
                                    >
                                      <img src={externalLinkIcon} alt="" />
                                    </Button>
                                  </TableCell>
                                )}
                              </>
                            )}

                            {activeTab === ItemTab.tabC && (
                              <>
                                <TableCell style={{ height: "auto" }}>
                                  <div className={classes.flex}>
                                    <MyTypography
                                      variant={"body3"}
                                      className={classes.flex5}
                                      data-testid={`lines[${index}].shipToParty-text`}
                                    >
                                      {formik.values.lines[index]?.shipTo}
                                    </MyTypography>
                                    {(options?.length || 0) > 1 ? (
                                      <Button
                                        id={`lines[${index}].changeShipToPartyButton`}
                                        data-testid={`lines[${index}].changeShipToPartyButton`}
                                        variant={"outlined"}
                                        color={"secondary"}
                                        className={classNames(
                                          classes.btnThin,
                                          classes.flex1
                                        )}
                                        onClick={() => {
                                          handleOpenModalAddress(line.id);
                                        }}
                                      >
                                        <MyTypography variant={"body3"}>
                                          {intl.formatMessage({
                                            defaultMessage: "แก้ไข"
                                          })}
                                        </MyTypography>
                                      </Button>
                                    ) : null}
                                  </div>
                                </TableCell>
                                {/* <TableCell>
                              <TextAreaField
                                maxLength={1320}
                                verticalResizingOnly
                                minWidth={376}
                                zoomable
                                className={classes.textField}
                                lineLimit={132}
                                rowsMax={10}
                                name={`lines[${index}].internalCommentsToLogistic`}
                                value={
                                  formik.values.lines[index]
                                    ?.internalCommentsToLogistic || ""
                                }
                                onChange={() => null}
                                onBlur={formik.handleChange}
                              />
                            </TableCell> */}
                                <TableCell>
                                  <TextAreaField
                                    id={`lines[${index}].internalCommentsToWarehouse`}
                                    data-testid={`lines[${index}].internalCommentsToWarehouse`}
                                    maxLength={1320}
                                    className={classes.textField}
                                    lineLimit={132}
                                    verticalResizingOnly
                                    rowsMax={10}
                                    minWidth={197}
                                    zoomable
                                    name={`lines[${index}].internalCommentsToWarehouse`}
                                    value={
                                      formik.values.lines[index]
                                        ?.internalCommentsToWarehouse || ""
                                    }
                                    onChange={() => null}
                                    onBlur={formik.handleChange}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextAreaField
                                    id={`lines[${index}].externalCommentsToCustomer`}
                                    data-testid={`lines[${index}].externalCommentsToCustomer`}
                                    maxLength={1320}
                                    lineLimit={132}
                                    minWidth={197}
                                    zoomable
                                    verticalResizingOnly
                                    className={classes.textField}
                                    rowsMax={10}
                                    name={`lines[${index}].externalCommentsToCustomer`}
                                    value={
                                      formik.values.lines[index]
                                        ?.externalCommentsToCustomer || ""
                                    }
                                    onChange={() => null}
                                    onBlur={formik.handleChange}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextAreaField
                                    id={`lines[${index}].shippingMark`}
                                    data-testid={`lines[${index}].shippingMark`}
                                    maxLength={1320}
                                    lineLimit={132}
                                    minWidth={197}
                                    zoomable
                                    verticalResizingOnly
                                    className={classes.textField}
                                    rowsMax={10}
                                    name={`lines[${index}].shippingMark`}
                                    value={line?.shippingMark}
                                    onChange={() => null}
                                    onBlur={formik.handleChange}
                                  />
                                </TableCell>
                                {/* <TableCell>
                              <TextAreaField
                                minWidth={376}
                                zoomable
                                verticalResizingOnly
                                maxLength={1320}
                                lineLimit={132}
                                className={classes.textField}
                                rowsMax={10}
                                name={`lines[${index}].productInformation`}
                                value={
                                  formik.values.lines[index]
                                    ?.productInformation || ""
                                }
                                onChange={() => null}
                                onBlur={formik.handleChange}
                              />
                            </TableCell> */}
                              </>
                            )}
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={20}>
                          <Skeleton />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <StickyHorizontalScrollBar
                  key={`scroll-${currentTab}`}
                  container={containerRef}
                  reRender={reRender}
                  bottom={173}
                />
                {openModalAddress && (
                  <ModalAddress
                    onClose={handleCloseModalAddress}
                    visible={openModalAddress}
                    type={RealtimePartnerType.SHIP_TO}
                    options={options}
                    handleApplyAddress={handleOnApplyAddress}
                    formik={formik}
                    partnerName=""
                    partnerNo=""
                  />
                )}
                <ModalInputParameter
                  loading={loadingPassParameter}
                  orderId={currentSelect}
                  open={openInputParameter}
                  onClose={() => {
                    setOpenInputParameter(false);
                    setCurrentSelect(null);
                  }}
                  onSave={handleSaveInputParam}
                  initialValue={
                    formik.values.lines.find(item => item.id === currentSelect)
                      ?.inquiryMethodCode
                  }
                />
              </div>
              <TablePaginationCustom
                hasNextPage={
                  pageInfo && !disabled ? pageInfo.hasNextPage : false
                }
                hasPreviousPage={
                  pageInfo && !disabled ? pageInfo.hasPreviousPage : false
                }
                rowNumberSet={BIG_ROW_NUMBER_SET}
                onNextPage={onNextPage}
                onPreviousPage={onPreviousPage}
                totalCount={totalCount}
                selectColor="#007E92"
                settings={settings}
                onUpdateListSettings={onUpdateListSettings}
                isBackFistPage
                isNextLastPage
                latestPageItemNumber={latestPageItemNumber}
                onNextLastPage={onNextLastPage}
                onPreviousFirstPage={onPreviousFirstPage}
                disabled={disabled}
              />
            </>
          ) : activeTab === ItemTab.tabD && cashSaleFormProps ? (
            <CashSaleForm {...cashSaleFormProps} />
          ) : null}
        </>
      )}

      {!orderLineListAll?.length ? <EmptyProduct hideTotal /> : null}
    </div>
  );
};

export default forwardRef(ItemDetailsTab);
